import { useMemo } from "react";
import apiClient from "./apiClient";
import axios, { AxiosProgressEvent } from "axios";
import { Layer, LayerCreatePayload, LayerCreateResponse } from "../state/types";

const useLayerApi = () =>
  useMemo(
    () => ({
      createLayerApi: async (payload: LayerCreatePayload): Promise<LayerCreateResponse> => {
        const { data } = await apiClient.post<LayerCreateResponse>("/layer/create", payload);
        return data;
      },
      // GET /layer — all params optional. No params scans the whole table;
      // category queries one partition; category + group narrows by SK prefix.
      listLayersApi: async (category?: string, group?: string): Promise<Layer[]> => {
        const params: Record<string, string> = {};
        if (category) params.category = category;
        if (group) params.group = group;
        const { data } = await apiClient.get("/layer", {
          params: Object.keys(params).length ? params : undefined,
        });
        return (data?.layers as Layer[]) || [];
      },
      uploadLayerFileApi: async (
        presignedUrl: string,
        file: File,
        contentType: string, // MUST equal payload.contentType
        onProgress?: (pct: number) => void
      ) =>
        axios.put(presignedUrl, file, {
          headers: { "Content-Type": contentType },
          onUploadProgress: (e: AxiosProgressEvent) =>
            onProgress?.(Math.round((e.loaded * 100) / (e.total || 1))),
        }),
    }),
    []
  );

export default useLayerApi;
